<template>
  <el-drawer
    class="drawer-style"
    :title="$t('messageBox.title')"
    :visible.sync="drawerVisiable"
    direction="rtl"
    size="600px"
    :before-close="messageBoxCloseHandle"
  >
    <div class="message-container">
      <div class="tab-container">
        <el-button
          v-if="activeName == 'first'"
          class="read-all-btn"
          @click="readAllMessage"
        >
          {{ $t("button.allRead") }}</el-button
        >
        <el-tabs v-model="activeName" @tab-click="tabChange">
          <el-tab-pane name="first">
            <template slot="label">
              <span>{{ $t("messageBox.unreadMessage") }}</span>
              <el-badge
                v-if="unReadMessageCount > 0"
                :value="unReadMessageCount"
                class="message-badge-count"
              >
              </el-badge>
            </template>
          </el-tab-pane>
          <el-tab-pane
            :label="$t('messageBox.readMessage')"
            name="second"
          ></el-tab-pane>
        </el-tabs>
      </div>
      <div class="message-list-container" v-if="messageList.length">
        <ul
          class="message-list"
          v-infinite-scroll="getMessageInfo"
          :infinite-scroll-disabled="disabled"
        >
          <li
            @click="readMessage(message)"
            v-for="message in messageList"
            :key="message.id"
            class="message-content"
            :class="message.type"
          >
            <div class="message-icon">
              <i class="HSIconfont hs-icon-notification1"></i>
            </div>
            <div class="message-detail">
              <p class="msg-type">
                {{ $t(`messageBox.${message.type}`) }}
              </p>
              <p class="msg-title">
                {{ message.title[language] || message.title["en"] }}
              </p>
              <p class="create-time">{{ dataToString(message.createTime) }}</p>
            </div>
          </li>
        </ul>
        <el-icon v-if="loading" class="el-icon-loading"></el-icon>
        <p class="no-more-style">
          <span v-if="noMore">{{ $t("messageBox.noMore") }}</span>
        </p>
      </div>
      <div v-else class="no-data">
        <img src="../../../assets/nodata.png" alt="" />
        <p class="no-data-span">{{ $t("messageBox.empty") }}</p>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import to from "await-to-js";
import { dataToString } from "@/utils/utils";
import { initState as globalState } from "@/store/shardActions";
import { closeAllMessage } from "@/common/noticeTip";
export default {
  props: ["value", "drawer"],
  watch: {
    value(v) {
      this.drawerVisiable = v;
    },
  },
  computed: {
    language() {
      return globalState.currentLanguage;
    },
    unReadMessageCount() {
      return this.$store.state.wsStore.count == 0
        ? null
        : this.$store.state.wsStore.count;
    },
    disabled() {
      return this.loading || this.noMore;
    },
  },

  data() {
    return {
      drawerVisiable: this.value,
      activeName: "first",
      messageList: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
      },
      loading: false,
      noMore: false,
    };
  },

  created() {
    this.getMessageInfo();
  },

  methods: {
    dataToString,
    close() {
      this.$emit("input", false);
    },
    tabChange() {
      // this.messageList = [];
      this.pagination.currentPage = 1;
      this.noMore = false;
      this.getMessageInfo(true);
    },
    async readAllMessage() {
      const [err, res] = await to(this.$httpList.readAllMessage());
      if (err) {
        return;
      }
      if (res.resultCode == 1001) {
        this.$notify.success(this.$t("messageBoxPromptMessage.allRead"));
        closeAllMessage();
      }
      this.tabChange();
    },

    async getMessageInfo(clear = false) {
      this.loading = true;
      let searchData = {
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        readStatus: this.activeName != "first",
        createTimeSort: "DESC",
      };
      const [err, res] = await to(
        this.$httpList.getInboxMessageList(searchData)
      );
      this.loading = false;
      if (err) {
        return;
      }
      this.messageList = clear ? [] : this.messageList;
      if (res.resultCode == 1001) {
        if (this.activeName == "first") {
          this.$store.commit("wsStore/changeCount", res.data.count);
        }
        this.pagination.currentPage++;
        let list = res.data.pageData || [];
        const msgList=[...this.messageList, ...list];
        this.messageList = msgList.filter((msg,index)=>{
          return msgList.findIndex(val=>val.id==msg.id)===index
        })
        if (
          res.data.pageData &&
          res.data.pageData.length < this.pagination.pageSize
        ) {
          this.noMore = true;
        }
      }
    },

    readMessage(message) {
      this.$store.dispatch("config/readMessage", {
        show: true,
        id: message.id,
      });
      if (this.activeName == "first") {
        this.messageList = this.messageList.filter(
          (msg) => msg.id != message.id
        );
        this.pagination.currentPage--;
        this.getMessageInfo()
        // let count = this.unReadMessageCount - 1;
        // this.$store.commit("wsStore/changeCount", count);
      }
    },

    messageBoxCloseHandle() {
      this.close();
    },
  },
};
</script>

<style lang="scss">
.drawer-style {
  .el-drawer__header {
    height: 44px;
    margin: 0;
    padding: 0 16px;
    border-bottom: 1px solid #e8e8e8;
  }
  .message-container {
    padding-left: 16px;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .tab-container {
      position: relative;
      padding-top: 10px;
      .read-all-btn {
        position: absolute;
        right: 16px;
        top: 13px;
        z-index: 99;
        font-size: 12px;
      }
    }

    .no-data {
      padding-top: 100px;
      text-align: center;
      img {
        width: 400px;
      }
      .no-data-span {
        opacity: 0.65;
        color: $font-color-regular;
      }
    }
  }
  .message-badge-count {
    ::v-deep .el-badge__content {
      top: 8px;
    }
  }
  .message-list-container {
    padding-right: 16px;
    flex-grow: 1;
    overflow: auto;
  }
  .message-list {
    li {
      cursor: pointer;
    }
    padding-left: 0;
    .img {
      flex-shrink: 0;
    }
    .message-content {
      display: flex;
      .message-icon {
        width: 24px;
        height: 24px;
        font-size: 16px;
        border-radius: 50%;
        text-align: center;
        line-height: 24px;
        margin-right: 8px;
        i {
          color: #fff;
        }
      }
      &.NORMAL_NOTICE {
        .message-icon {
          background-color: $primary;
        }
        .msg-type {
          color: $font-color-primary;
        }
      }

      &.IMPORTANT_NOTICE {
        .message-icon {
          background-color: $color-warning;
        }
        .msg-type {
          color: $color-warning;
        }
      }
      &.WARNING_NOTICE {
        .message-icon {
          background-color: $color-danger;
        }
        .msg-type {
          color: $color-danger;
        }
      }
      .message-detail {
        p {
          margin: 0;
        }
        flex: 1;
        padding-bottom: 16px;
        border-bottom: 1px solid $border-color;
        margin-bottom: 13px;
        .msg-type {
          margin: 0;
        }
        .msg-title {
          max-height: 36px;
          line-height: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          word-break: break-all;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          margin: 8px 0;
          color: $font-color-regular;
        }
        .create-time {
          font-size: 12px;
          color: #999;
        }
      }
    }
  }
  .no-more-style {
    text-align: center;
    color: $font-color-regular;
    font-size: 14px;
  }
}
</style>
